import React, { useState, useEffect } from "react";
import { maintenanceService } from "../maintenanceService"
import { useMaintenanceModel } from "../maintenanceModel";
import { IMaintenanceDetail, IMaintenanceSearch } from "../maintenanceType"
import { momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void;
  printParam: IMaintenanceSearch;
}

export const PrintMaintenanceTable = (props: PropsType) => {
  const { printVisible, setPrintVisible, printParam } = props;
  const { descRows } = useMaintenanceModel();
  const [dataSource, setDataSource] = useState<any>([]);
  const [pageCount, setPageCount] = useState<number>(1);

  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printVisible) {
      maintenanceService.findAllDetail(printParam).then((res) => {
        let list: IMaintenanceDetail[] = res.retData;
        if (descRows != null && descRows.length > 0) {
          const codes = descRows.map(e => e.maintenanceCode);
          list = list.filter(e => codes.includes(e.maintenanceCode));
        }
        list = list.map(e => {
          return {
            ...e,
            completeTime: e.completeTime ? momentFormat(e.completeTime, "YYYY年MM月DD日 HH时mm分") : '',
            dispatchTime: e.dispatchTime ? momentFormat(e.dispatchTime, "YYYY年MM月DD日 HH时mm分") : '',
            stockIoTime: e.stockIoTime ? momentFormat(e.stockIoTime, "YYYY年MM月DD日 HH时mm分") : '',
          }
        })
        if (list.length !== 0) {
          setPageCount(list.length);
          setDataSource(list);
          print();
        }
        else {
          setPrintVisible(false);
        }
      })
    }
  }, [printVisible])

  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        {Array.from({ length: pageCount }).map((_, pageIndex) => (
          <>
            <div style={{ display: 'flex', width: '100%', height: '100%' }}>
              <div style={{ flex: 9 }}>
                <div style={{ marginTop: 11, textAlign: 'center', fontSize: 28, fontFamily: "FangSong", fontWeight: 'bold' }}>{`${shopName}车辆维修单`}</div>
                <div style={{ fontSize: 14, fontFamily: "FangSong" }}>
                  <div style={{ display: 'block', textAlign: "right", marginTop: 5 }}>
                    派工编号: {dataSource[pageIndex]?.maintenanceCode}
                  </div>
                  <div style={{ display: 'block', textAlign: "right", marginTop: 5 }}>
                    {dataSource[pageIndex]?.dispatchTime ?
                      <span>派工时间:<span style={{ marginLeft: 10 }}>{dataSource[pageIndex]?.dispatchTime}</span></span>
                      : <span style={{ marginRight: 194 }}>派工时间:</span>
                    }
                  </div>
                  <div style={{ display: 'block', textAlign: "right", marginTop: 5 }}>
                    {dataSource[pageIndex]?.completeTime ?
                      <span>竣工时间:<span style={{ marginLeft: 10 }}>{dataSource[pageIndex]?.completeTime}</span></span>
                      : <span style={{ marginRight: 194 }}>竣工时间:</span>
                    }
                  </div>
                </div>
                <table className="mingxi" style={{ border: "1px solid black", marginTop: 5 }}>
                  <tbody>
                    <tr>
                      <td style={{ width: '50%', fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>公司名称:{dataSource[pageIndex]?.customerName}</td>
                      <td style={{ width: '25%', fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>车牌号:{dataSource[pageIndex]?.licensePlate}</td>
                      <td style={{ width: '25%', fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>车辆编号:{dataSource[pageIndex]?.vehicleNumber}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>车&nbsp;&nbsp;&nbsp;&nbsp;型:{dataSource[pageIndex]?.brandName}({dataSource[pageIndex]?.vehicleTypeName})</td>
                      <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>公里数:{dataSource[pageIndex]?.mileage}</td>
                      <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>
                        车辆是否外修:
                        {dataSource[pageIndex]?.serviceLocationName === "站内" &&
                          <span style={{ marginLeft: 20 }}>否</span>
                        }
                        {dataSource[pageIndex]?.serviceLocationName === "站内-上门" &&
                          <span style={{ marginLeft: 20 }}>否</span>
                        }
                        {dataSource[pageIndex]?.serviceLocationName === "站外" &&
                          <span style={{ marginLeft: 20 }}>是</span>
                        }
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }} colSpan={1}>故障描述</td>
                      <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }} colSpan={2}>维修项目</td>
                    </tr>

                    {dataSource[pageIndex] ? (
                      <>
                        <tr>
                          <td
                            style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }}
                            rowSpan={dataSource[pageIndex].additionalItems ? 2 : 5}
                          >
                            {dataSource[pageIndex].faultDesc}
                          </td>

                          {dataSource[pageIndex]?.itemDetailList?.length > 0 ? (
                            <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                              1、{dataSource[pageIndex].itemDetailList[0].itemName}
                            </td>
                          ) : (
                            <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>1、</td>
                          )}
                        </tr>

                        <tr>
                          {dataSource[pageIndex]?.itemDetailList?.length > 1 ? (
                            <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                              2、{dataSource[pageIndex].itemDetailList[1].itemName}
                            </td>
                          ) : (
                            <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>2、</td>
                          )}
                        </tr>

                        {dataSource[pageIndex].additionalItems && (
                          <>
                            <tr>
                              <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>维修附加项</td>

                              {dataSource[pageIndex]?.itemDetailList?.length > 2 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  3、{dataSource[pageIndex].itemDetailList[2].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>3、</td>
                              )}
                            </tr>

                            <tr>
                              <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} rowSpan={2}>
                                {dataSource[pageIndex].additionalItems}
                              </td>

                              {dataSource[pageIndex]?.itemDetailList?.length > 3 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  4、{dataSource[pageIndex].itemDetailList[3].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>4、</td>
                              )}
                            </tr>

                            <tr>
                              {dataSource[pageIndex]?.itemDetailList?.length > 4 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  5、{dataSource[pageIndex].itemDetailList[4].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>5、</td>
                              )}
                            </tr>
                          </>
                        )}

                        {!dataSource[pageIndex].additionalItems && (
                          <>
                            <tr>
                              {dataSource[pageIndex]?.itemDetailList?.length > 2 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  3、{dataSource[pageIndex].itemDetailList[2].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>3、</td>
                              )}
                            </tr>

                            <tr>
                              {dataSource[pageIndex]?.itemDetailList?.length > 3 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  4、{dataSource[pageIndex].itemDetailList[3].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>4、</td>
                              )}
                            </tr>

                            <tr>
                              {dataSource[pageIndex]?.itemDetailList?.length > 4 ? (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>
                                  5、{dataSource[pageIndex].itemDetailList[4].itemName}
                                </td>
                              ) : (
                                <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={2}>5、</td>
                              )}
                            </tr>
                          </>
                        )}
                      </>
                    ) : (
                      Array.from({ length: 5 }).map((_, i) => (
                        <tr key={`empty-row-${i}`} style={{ height: 22 }}>
                          <td style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }} colSpan={3}>
                            {i + 1}、
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal', marginTop: 5 }}>
                  {/* <span>维修负责人签字: {dataSource[pageIndex]?.dispatcher}</span> */}
                  <span>维修负责人签字:</span>
                  <span style={{ marginLeft: 40 }}>维修人员签字: {dataSource[pageIndex]?.technicianNames}</span>
                  <span style={{ float: 'right', marginRight: 60 }}>验收人员签字:</span>
                </div>

                <div style={{ marginTop: 11 }}>
                  <div style={{ textAlign: 'center', fontSize: 24, fontFamily: "FangSong", fontWeight: 'bold' }}>维保材料明细</div>
                  <div style={{ display: 'block', textAlign: "right", fontSize: 14, fontFamily: "FangSong", marginTop: 5 }}>
                    {dataSource[pageIndex]?.stockIoTime ?
                      <span>领料时间:<span style={{ marginLeft: 10 }}>{dataSource[pageIndex]?.stockIoTime}</span></span>
                      : <span style={{ marginRight: 194 }}>领料时间:</span>
                    }
                  </div>
                  <table className="mingxi" style={{ border: "1px solid black", marginTop: 5 }}>
                    <thead>
                      <tr>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>序号</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>配件编码</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>配件名称</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>型号</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>单位</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>领取数量</th>
                        <th style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>备注</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataSource[pageIndex]?.materialDetailList?.map((row: any, rowIndex: any) => (
                        <tr key={rowIndex} style={{ height: 22 }}>
                          <td style={{ width: 36, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{rowIndex + 1}</td>
                          <td style={{ width: 102, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{row.materialCode}</td>
                          <td style={{ width: 112, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{row.materialName}</td>
                          <td style={{ width: 112, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{row.model}</td>
                          <td style={{ width: 36, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{row.unitName}</td>
                          <td style={{ width: 42, fontSize: 12, fontFamily: "FangSong", fontWeight: 'bold', textAlign: 'center', }}>{row.num}</td>
                          <td style={{ width: 42, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', }}>{row.note}</td>
                        </tr>
                      ))}
                      {Array.from({
                        length: Math.max(20 - (dataSource[pageIndex]?.materialDetailList?.length ?? 0), 0)
                      }).map((_, i) => (
                        <tr key={`materialEmpty-${i}`} style={{ height: 22 }}>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div style={{ display: 'flex', marginTop: 5, fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>
                    {/* <div style={{ flex: 2 }}>维修负责人签字: {dataSource[pageIndex]?.materialDetailList?.length > 0 && dataSource[pageIndex]?.dispatcher}</div> */}
                    <div style={{ flex: 2 }}>维修负责人签字:</div>
                    <div style={{ flex: 3 }}>领料人员签字: {dataSource[pageIndex]?.materialDetailList?.length > 0 && (
                      <>
                        &nbsp;
                        {dataSource[pageIndex]?.technicianNames?.split(",")?.[0]}
                      </>
                    )}</div>
                    <div style={{ flex: 2 }}>库房人员签字: {dataSource[pageIndex]?.storekeeper}</div>
                  </div>
                  <div style={{ display: 'flex', marginTop: 5, fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>
                    <div style={{ flex: 2 }}></div>
                    <div style={{ flex: 3 }}></div>
                    <div style={{ flex: 2 }}>对方公司验收人员签字:</div>
                  </div>
                  <div style={{ fontSize: 14, fontFamily: "FangSong", fontWeight: 'normal' }}>
                    <div>注：</div>
                    <div>1、派工前对方是否有派工单。</div>
                    <div>2、填写时车牌号前是否比对来车车号，填写公里数前是否看仪表盘上的公里数。</div>
                    <div>3、字迹填写清晰。</div>
                  </div>
                </div>
              </div>
              <div style={{ writingMode: "vertical-rl" }}>
                <span style={{ marginTop: '20%', fontSize: 20, fontFamily: "FangSong", fontWeight: 'normal' }}>一存根</span>
                <span style={{ marginTop: '5%', fontSize: 20, fontFamily: "FangSong", fontWeight: 'normal' }}>二库房</span>
                <span style={{ marginTop: '5%', fontSize: 20, fontFamily: "FangSong", fontWeight: 'normal' }}>三财务</span>
                <span style={{ marginTop: '5%', fontSize: 20, fontFamily: "FangSong", fontWeight: 'normal' }}>四子公司</span>
              </div>
            </div>
            {dataSource[pageIndex]?.materialDetailList.length > 20 && <div style={{ display: 'flex', width: '100%', height: '100%' }}></div>}
          </>
        ))}
      </div>
    </div >
  );
};